import Vue from "vue";
export const state = Vue.observable({
  name: '',
  openWindow: '',
  order: {},
  filters: {},
  terms_search: [],
  terms_requireds: [],
  terms_optionals: [],
  terms_excluded: [],
  sub_search_selected: [],
  sub_search_options: [],
  sub_search_value: [],
  sub_search_value_other: [],
  amount_sub_search: [0],
  where: {},
  search_flag: false,
});

export const mutationsMap = {
  setName: (name) => {
    state.name = name
  },
  setOpenWindow: (name) => {
    state.openWindow = name
  },
  setOrder: (order) => {
    state.order = order
  },
  setTermsRequired: (terms_requireds) => {
    state.terms_requireds = terms_requireds;
  },
  setTermsOptionals: (terms_optionals) => {
    state.terms_optionals = terms_optionals
  },
  setTermsExcluded: (terms_excluded) => {
    state.terms_excluded = terms_excluded
  },
  setTermsSearch: (terms_search) => {
    state.terms_search = terms_search
  },
  setSearchFlag: () => {
    state.search_flag = !state.search_flag
  },
  setFilters: (field) => {
    state.filters = { ...state.filters, ...field }
  },
  setSubSearchSelected: (sub_search_selected) => {
    state.sub_search_selected = sub_search_selected
  },
  setSubSearchOptions: (sub_search_options) => {
    state.sub_search_options = sub_search_options
  },
  setSubSearchValue: (sub_search_value) => {
    state.sub_search_value = sub_search_value
  },
  setSubSearchValueOther: (sub_search_value) => {
    state.sub_search_value_other = sub_search_value
  },
  setAmountSubSearch: (amount) => {
    state.amount_sub_search = amount
  },
  setWhere: (field) => {
    state.where = field
  },
  removeFilter: (field) => {
    delete state.filters[field]
  }
}

export const gettersMap = {
  getName: () => { return state.name },
  getOpenWindow: () => { return state.openWindow },
  getOrder: () => { return state.order },
  getFilters: () => { return state.filters },
  getTermsRequireds: () => { return state.terms_requireds },
  getTermsOptionals: () => { return state.terms_optionals },
  getTermsExcluded: () => { return state.terms_excluded },
  getTermsSearch: () => { return state.terms_search },
  getWhere: () => { return state.where },
  getSearchFlag: () => { return state.search_flag },
  getSubSearchValue: () => { return state.sub_search_value },
  getSubSearchValueOther: () => { return state.sub_search_value_other },
  getSubSearchOptions: () => { return state.sub_search_options },
  getSubSearchSelected: () => { return state.sub_search_selected },
  getAmountSubSearch: () => { return state.amount_sub_search }
}